export default {
  0: "normal",
  1: "zen",
  2: "zen-light",
  normal: 0,
  zen: 1,
  "zen-light": 2
};
